import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { messages } from '../../messages';
import style from '../../style.module.less';
/**
 *
 * @param {object} props
 * @param {string} props.invoiceId
 * @returns {JSX.Element}
 */
const InvoiceDownloadColumn = ({ invoiceId }) => (
  <div className={style['item-cell']}>
    <Button href={`/api/account/downloadInvoice/${invoiceId}`} target='_blank' theme='link'>
      <FormattedMessage {...messages.invoiceDownload} />
    </Button>
  </div>
);

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.invoiceDownload} />,
  id: 'invoiceDownload',
  render: InvoiceDownloadColumn,
};
